import { render, staticRenderFns } from "./comp_AnimalHeader.vue?vue&type=template&id=90c20bf4&"
import script from "./comp_AnimalHeader.vue?vue&type=script&lang=js&"
export * from "./comp_AnimalHeader.vue?vue&type=script&lang=js&"
import style0 from "./comp_AnimalHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports